import React from 'react';
import PropTypes from 'prop-types';
import { BudgetIcon } from 'taboola-ultimate-ui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import SectionHeader from 'modules/campaigns/components/Form/SectionHeader/SectionHeader';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

const BudgetSectionFrame = ({ children, isBudgetHidden, isInitiallyCollapsed }) => (
    <CommonCollapsibleCard
        id="CAMPAIGN_BUDGET_BIDDING"
        header={
            <SectionHeader
                headerIcon={<BudgetIcon />}
                headerText={
                    <FormattedMessage
                        id={isBudgetHidden ? 'campaign.editor.bidding.title' : 'campaign.editor.budget.and.bidding'}
                        defaultMessage={isBudgetHidden ? 'Bidding' : 'Budget and Bidding'}
                    />
                }
            />
        }
        isInitiallyCollapsed={isInitiallyCollapsed}
    >
        {children}
    </CommonCollapsibleCard>
);

BudgetSectionFrame.propTypes = {
    children: PropTypes.node,
};

export default BudgetSectionFrame;
